<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">異常設備清單</div>
        </div>
        <!--異常設備清單-->
        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              設備清單
              <button class="btn btn-info">新增</button>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="10%">風景區</th>
                      <th scope="col">地點</th>
                      <th scope="col">設備種類(名稱)</th>
                      <th scope="col">設備ID</th>
                      <th scope="col">設備IP</th>
                      <th scope="col">連線狀態</th>
                      <th scope="col">設定</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in dashbords"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.location }}</td>
                      <td>{{ item.pname }}</td>
                      <td>{{ item.pid }}</td>

                      <td>{{ item.pip }}</td>
                      <td :class="item.statusErrorColor">{{ item.status }}</td>
                      <td>
                        <button class="btn btn-info">編輯</button>
                        <button class="btn btn-danger ml-2">刪除</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          name: "石梯坪",
          location: "男廁",
          pname: "監視器_計數",
          pid: "20003",
          status: "離線",
          statusErrorColor: "text-danger font-weight-bold h5",
          pip: "192.1.1.1",
        },
        {
          name: "石梯坪",
          location: "男廁",
          pname: "監視器",
          pid: "20003",
          status: "連線",
          statusErrorColor: "",
          pip: "192.1.1.2",
        },
        {
          name: "石梯坪",
          location: "女廁",
          pname: "監視器_計數",
          pid: "20003",
          status: "連線",
          statusErrorColor: "",
          pip: "192.1.1.3",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>